
function SdFavoritesCtrl(TranslationService, ToastService, StoreService, $uibModal) {
    var ctrl = this;    

    ctrl.translation = TranslationService.getActiveTranslation();
    ctrl.allItemsText = '(All)';
    ctrl.$onInit = function () {
        //console.log('sd-favorites.onInit');
        //ctrl.refreshPicklist();
        ctrl.allItems = {
            FavoriteName: ctrl.allItemsText, Skus: [], AllItems: true
        };
    };

    ctrl.selectItem = function (item) {
        ctrl.ngModel = item;
        //ctrl.$setViewValue(item);

        ctrl.onSelect({ item: item });
    };

    ctrl.showFavorite = function (favorite) {
        var modalInstance = $uibModal.open({
            templateUrl: 'SPA/quotes/skuFavoritesAddModal.html',
            controller: 'SkuFavoritesAddModalController',
            size: 'sm',
            resolve: {
                favorite: function () {
                    return favorite;
                },
            }
        });
        return modalInstance;
    };

    ctrl.addNew = function () {
        var favorite = {
            ContactID: ctrl.contactId,
            FavoriteName: 'Nem List',
            Skus: [],
        };
        var modalInstance = ctrl.showFavorite(favorite);
        modalInstance.result.then(
            function (favorite) {
                //$scope.dash.favorite = favorite;                
                //ctrl.items.push(favorite);
                ctrl.save(favorite, true);
            }
        );
    };

    ctrl.editItem = function (ev, favorite) {
        console.log('editItem');
        ev.preventDefault();
        ev.stopPropagation();

        var modalInstance = ctrl.showFavorite(favorite);
        modalInstance.result.then(
            function (favorite, action) {
                console.log('EDIT ITEM SAVE');                
                if (favorite.ActionID == 'delete') {
                    ctrl.deleteFav(favorite);                    
                }
                else
                {
                    ctrl.save(favorite, false);
                }
            }
        );

    };


    ctrl.openModalDelete = function() {
        return $uibModal.open({
            templateUrl: './SPA/Shared/delete-modal.html',
            controller: 'DeleteModalCtrl as ctrl',
            size: 'md',
            resolve: {
                translation: function () {
                    return ctrl.translation;
                },
            }
        });
    }

    /*
    function modalDeleteResult(modalInstance) {
        modalInstance.result.then(function (response) {
            if (response == 'true') confirmDeleteEmail();
        });
    }
    */

    ctrl.deleteFav = function (favorite) {
        console.log('Delete FAVORITE');

        var modal = ctrl.openModalDelete();
        modal.result.then(function (response) {
            if (response == 'true') {
                var toastID = ToastService.createToast('Removendo', 'Fav', 4000, 'wait');
                StoreService.deleteFavorite(favorite).then(
                    function (response) {
                        console.log(response);
                        ToastService.updateToast(toastID, 'Removido', '', 4000, 'success');

                        var index = ctrl.items.indexOf(favorite);
                        if (index >= 0) {
                            ctrl.items.splice(index, 1);
                        }
                        if (favorite == ctrl.ngModel) {
                            ctrl.ngModel = null;
                        }
                    },
                    function (err) {
                        console.log(err);
                        ToastService.updateToast(toastID, 'Erro remover', err.data.ExceptionMessage, 4000, 'error');
                    }
                );
            }
        });        
    };

    ctrl.save = function (favorite, addToList) {
        var toastID = ToastService.createToast('Adicionando', 'Fav', 4000, 'wait');
        StoreService.saveFavorite(favorite).then(
            function (response) {
                console.log('favorite SAVE');
                console.log(response);
                if (addToList) {
                    ctrl.items.push(favorite);
                    if (response.data.FavoriteID) {
                        favorite.FavoriteID = response.data.FavoriteID;
                        ctrl.selectItem(favorite); //SELECIONA LISTA CRIADA
                    }
                }                
                ToastService.updateToast(toastID, 'Salvo', '', 4000, 'success');
            },
            function (err) {
                console.log(err);
                ToastService.updateToast(toastID, 'Erro adicionar', err.data.ExceptionMessage, 4000, 'error');
            }
        );
    };
}

SdFavoritesCtrl.$inject = ['TranslationService', 'ToastService', 'StoreService', '$uibModal'];

seedWebApp.component('sdFavorites', {
    controller: SdFavoritesCtrl,
    bindings: {
        contactId: '<',        
        items: '<',        
        hideAll: '<',
        //selItem: '=',
        ngModel: '=',
        onSelect: '&',
    },
    templateUrl: '/SPA/Components/sd-favorites.html' + seedWebApp.buildVersion
});